<template>
  <div class="container">
    <el-empty
      :image="icon"
      :image-size="400"
      description="页面出差了..."
    ></el-empty>
  </div>
</template>

<script>
import icon from "../assets/404.svg";
export default {
  name: "404",
  data() {
    return {
      icon,
    };
  },
};
</script>

<style scoped lang="scss">
.container {
  .el-empty {
    width: 100% !important;
  }
}
</style>
